/* eslint-disable eqeqeq */
// 3rd-party modules
import { message } from "antd";
import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

// project modules
import { apiCall } from "../../../helpers/apiHelper";
import Button from "../../shared/button";
import { convertToSnakecase } from "../../../helpers/objectHelper";
import Loader from "../../shared/loader";
import yup from "../../../plugins/yup";

// apis
import * as DashApi from '../../../apis/dashApi';

// models
import { Account } from "../../../models/account";
import { AccountKiboshDevice } from "../../../models/accountKiboshDevice";
import { kiboshDeviceWifiConfigUpdateViewModel } from "../../../models/types/kiboshDeviceWifiConfig";
import { ApiResponse } from "../../../models/response";
import Select from "../../shared/inputs/select";
import Checkbox from "../../shared/inputs/checkbox";
import { KiboshDeviceEmailAlert } from "../../../models/kiboshDeviceEmailAlert";
import { SelectProps } from "antd/lib";

type Props = {
  account?: Account;
  accountKiboshDevice: AccountKiboshDevice;
  refresh?: boolean;
  onCancel?: () => void;
  onSave?: (account: Account) => void;
};

export default function KiboshDeviceEmailAlerts({ account, refresh, accountKiboshDevice, onCancel, onSave }: Props) {
  const [loading, setLoading] = useState(false);
  const abortController = new AbortController();

  const options: SelectProps['options'] = [];

  const schema = yup.object().shape({
    notification_enabled: yup.bool().label("Status").required(),
    notification_email_addresses: yup.array()
    .of(
      yup.string()
        .email('Invalid email format') // Validate each email in the array
        .required('Email is required') // Ensure each email is not empty
    )
  });
  const { control, handleSubmit, reset } = useForm<kiboshDeviceWifiConfigUpdateViewModel | any>({
    defaultValues: {
      notification_enabled: false,
      notification_email_addresses: null
    },
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    getAccountKiboshDeviceStatusAsync();
  }, []);

  const getAccountKiboshDeviceStatusAsync = async () => {
    const data = await getAccountKiboshDeviceStatus();

    const currentData = {
      notification_enabled: data?.kiboshDevice?.notification_enabled,
      notification_email_addresses: data?.kiboshDevice?.notification_email_addresses,
      kibosh_device_id: accountKiboshDevice?.kiboshDeviceTypeCode == "dns" ? accountKiboshDevice?.kiboshDeviceReference : accountKiboshDevice?.accountKiboshDeviceId?.toString() || accountKiboshDevice?.kiboshDeviceReference!,
      kiboshDeviceReference: accountKiboshDevice?.kiboshDeviceTypeCode == "dns" ? accountKiboshDevice?.kiboshDeviceReference : accountKiboshDevice?.accountKiboshDeviceId?.toString() || accountKiboshDevice?.kiboshDeviceReference!
    }
    reset(currentData);
  }


  const getAccountKiboshDeviceStatus = async () => {
    setLoading(true);
    let kdId = accountKiboshDevice?.kiboshDeviceTypeCode == "dns" ? accountKiboshDevice?.kiboshDeviceReference : accountKiboshDevice?.accountKiboshDeviceId?.toString() || accountKiboshDevice?.kiboshDeviceReference!
    const response = await apiCall(DashApi.getKiboshDeviceStatus(kdId, abortController.signal));
    setLoading(false);

    return response.success ? response.data?.value : null;
  };
 
  const onSubmit: SubmitHandler<KiboshDeviceEmailAlert> = async (formData: KiboshDeviceEmailAlert) => {
    setLoading(true);

    const data = convertToSnakecase(formData, [], ["kiboshDeviceReference"]);

    const response: ApiResponse = await apiCall(DashApi.updateKiboshDeviceEmailAlert(data, abortController.signal));

    if (response.success) {
      message.success(`Email alert updated successfully.`);

      getAccountKiboshDeviceStatusAsync();

      if (onSave) onSave(response.data?.value);

    } else
      message.error(response.error?.value);

    setLoading(false);
  };

  return (
    <>
      {loading &&
        <Loader />
      }
      <view>
        <view data-scroll="">
        <group data-gap="15" data-space='15'>
            <group data-space-right='20'  data-gap="10" data-direction="column" width='auto'>
              <Checkbox
                control={control}
                name="notification_enabled"
                label="Enable/Disable"
                minimal
                dataLength="auto" />
              <Select
                label="Enter email to be alerted if Kibosh Filtering stops working."
                control={control}
                dataLength='500'
                name="notification_email_addresses"
                tokenSeparators={[","]}
                allowSearch={true}
                maxCount={3}
                mode="tags"
                notFoundContent={null}
                suffixIcon={null}
                options={options}
                dropdownStyle={{ display: "none" }} // Hide dropdown
              />
              <text data-wrap="wrap">To enter more than one, seperate with commos.</text>
            </group>
        </group>
        </view>
        <group data-space="10" data-gap="10">
          <Button data-length="forcefit" primary onClick={handleSubmit(onSubmit)}>
            <text>Save Changes</text>
          </Button>
        </group>
      </view>
    </>
  );
}
